export default __webpack_public_path__ + "static/media/qrStep3Icon.19e66cc7.png";